import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import Icon from "atoms/icons/icon";
import UserCollectionShareType from "models/enumerations/user-collection-share-type";
import UserCollectionRecord from "models/view-models/user-collection-record";
import UserCollectionVisibilityModal from "organisms/my-link/user-collections/user-collection-visibility-modal";
import React from "react";
import useUserCollectionInfo from "utilities/hooks/domain/users/user-collections/use-user-collection-info";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";

interface UserCollectionShareStatusProps {
    userCollection: UserCollectionRecord;
}

const CSS_CLASS_NAME = "c-user-collection-share-status";

const UserCollectionShareStatus = (props: UserCollectionShareStatusProps) => {
    const { userCollection } = props;

    const { collectionIconType, collectionShareLabel } =
        useUserCollectionInfo(userCollection);

    const { handleOpen, isOpen, handleClose } = useModalActions();

    // Work Group Info
    const numberOfWorkGroups = userCollection?.workGroups?.length ?? 0;
    const workGroupLableLink = `${numberOfWorkGroups} ${t(numberOfWorkGroups === 1 ? "workgroup" : "workgroups")}`;
    const workGroupTitles =
        userCollection?.workGroups
            ?.map((workGroup) => workGroup?.title ?? "")
            .sort((a, b) => a.localeCompare(b)) ?? [];

    return (
        <>
            {userCollection?.shareType !== UserCollectionShareType.User && (
                <>
                    <div className={`${CSS_CLASS_NAME}`}>
                        <Icon
                            type={collectionIconType}
                            size={IconSizes.Large}
                        />
                        {userCollection?.isWorkGroupCollection() ? (
                            <span className="c-label -small">
                                {collectionShareLabel}
                                <Button
                                    onClick={handleOpen}
                                    style={ButtonStyles.Anchor}>
                                    <span className="c-label -small">
                                        {workGroupLableLink}
                                    </span>
                                </Button>
                            </span>
                        ) : (
                            <span className="c-label -small">
                                {collectionShareLabel}
                            </span>
                        )}
                    </div>
                    <UserCollectionVisibilityModal
                        closeDialog={handleClose}
                        isVisible={isOpen}
                        title={userCollection?.name ?? ""}
                        workGroupTitles={workGroupTitles}
                    />
                </>
            )}
        </>
    );
};
export default UserCollectionShareStatus;
